export const LEGAL_DOCS = {
    privacy: {
        title: 'Política de Privacidad',
        lastUpdated: '2026-01-20',
        content: [
            {
                title: '1. Información que Recopilamos',
                text: 'GymProSV recopila únicamente la información estrictamente necesaria para la operación técnica y administrativa del servicio, incluyendo datos del gimnasio, perfiles de administradores y registros operativos (miembros, planes y transacciones registradas). No recopilamos, procesamos ni almacenamos datos financieros sensibles como números de tarjetas de crédito o cuentas bancarias.'
            },
            {
                title: '2. Uso de la Información',
                text: 'La información capturada se utiliza exclusivamente para la provisión del servicio contratado, la optimización técnica de la plataforma y la atención de solicitudes de soporte. GymProSV garantiza que no vende, alquila ni comparte información de sus clientes con terceros sin un consentimiento explícito, salvo requerimientos legales de autoridad competente.'
            },
            {
                title: '3. Integraciones de Terceros',
                text: 'Nuestra plataforma permite la integración con servicios externos de procesamiento de pagos, facturación o mensajería. Cada proveedor externo se rige por su propia política de privacidad. GymProSV no asume responsabilidad por el tratamiento de datos realizado exclusivamente por dichos proveedores.'
            },
            {
                title: '4. Control y Eliminación de Datos',
                text: 'El administrador del gimnasio posee el control total sobre su información y puede solicitar o ejecutar la eliminación de su cuenta y todos los datos asociados en cualquier momento a través de las herramientas disponibles en el sistema.'
            },
            {
                title: '5. Seguridad de la Información',
                text: 'Implementamos protocolos de seguridad y cifrado para proteger la integridad de los datos. Sin embargo, el usuario reconoce que ningún método de transmisión por internet es infalible ante ataques externos de fuerza mayor.'
            },
            {
                title: '6. Contacto',
                text: 'Para consultas relacionadas con esta política, puede escribirnos a: gymprosv@gmail.com'
            }
        ]
    },
    legal: {
        title: 'Aviso Legal',
        lastUpdated: '2026-01-20',
        content: [
            {
                title: 'Identificación',
                text: 'GymProSV es una plataforma de software como servicio (SaaS) desarrollada y operada desde El Salvador.'
            },
            {
                title: 'Garantía Limitada',
                text: 'El sistema se proporciona "tal cual" (as is), sin garantías explícitas o implícitas de idoneidad para un propósito particular. No garantizamos que el sistema esté libre de interrupciones o errores fuera de nuestro control razonable.'
            },
            {
                title: 'Alcance Operativo',
                text: 'GymProSV es una herramienta de gestión administrativa. No procesa flujos de dinero directamente, no actúa como pasarela financiera ni ofrece módulos de facturación electrónica propios de cumplimiento tributario sin la debida integración con proveedores autorizados.'
            },
            {
                title: 'Aceptación',
                text: 'El acceso y uso del sistema constituye la aceptación plena de estos términos, avisos legales y la política de privacidad adjunta.'
            }
        ]
    },
    disclaimer: {
        title: 'Disclaimer de Integraciones',
        lastUpdated: '2026-01-20',
        content: [
            {
                title: 'Naturaleza de las Integraciones',
                text: 'GymProSV facilita la conexión con servicios de terceros, incluyendo pero no limitado a pasarelas de pago, sistemas de facturación externa y servicios de mensajería (WhatsApp/Webhooks).'
            },
            {
                title: 'Responsabilidad Externa',
                text: 'GymProSV no ejerce control, administración ni garantía sobre la disponibilidad técnica o el cumplimiento legal de proveedores externos. Cualquier falla técnica, error de procesamiento, cobro indebido o incumplimiento fiscal derivado del uso de estos servicios es responsabilidad exclusiva del proveedor tercero y/o del administrador del gimnasio que contrata el servicio.'
            },
            {
                title: 'Uso Opcional',
                text: 'La activación de cualquier integración de terceros es completamente opcional y se realiza bajo la exclusiva responsabilidad y riesgo del usuario final.'
            }
        ]
    },
    terms: {
        title: 'Términos de Servicio',
        version: '1.0',
        lastUpdated: '2026-01-20',
        sections: [
            {
                title: '1. Introducción',
                content: 'Bienvenido a nuestra plataforma SaaS de gestión de gimnasios. Al utilizar este servicio, aceptas cumplir con los términos detallados en este documento. Este sistema está diseñado para ayudarte a gestionar la operación diaria de tu centro fitness de manera eficiente y segura.'
            },
            {
                title: '2. Uso Responsable',
                content: 'Como administrador, eres responsable de la veracidad de los datos ingresados y de mantener la confidencialidad de tus credenciales de acceso. El acceso no autorizado o el mal uso de los datos de tus clientes está estrictamente prohibido.'
            },
            {
                title: '3. Pagos y Suscripciones',
                content: 'El uso de la plataforma está sujeto al plan de suscripción seleccionado por tu gimnasio. Los cargos se realizarán según el ciclo de facturación acordado. La falta de pago puede resultar en la suspensión temporal de los servicios.'
            }
        ]
    }
};
